import { gql } from "apollo-angular";

import { ASSET_FRAGMENT } from "../../../common/graphql/fragments.graphql";

export { ADD_TO_CART } from "../../../common/graphql/fragments.graphql";

export { GET_STOREFRONT_CONSOLIDATED_FEED } from "../../../common/graphql/consolidated-feed.graphql";

export const GET_ACTIVE_CUSTOMER = gql`
    query GetActiveCustomer {
        activeCustomer {
            id
            firstName
            lastName
            emailAddress
        }
    }
`;

export const GET_PRODUCT_RETAIL_PRICE_RANGES = gql`
    query GetProductRetailPriceRanges($productIds: [ID!]!) {
        productRetailPriceRanges(productIds: $productIds) {
            productId
            min
            max
            currency
        }
    }
`;

export const GET_PRODUCT_RETAIL_PRICE_INFO = gql`
    query GetProductListRetailPriceInfo($productId: ID!) {
        productRetailPriceInfo(productId: $productId) {
            prices {
                marketplace
                countryName
                currency
                retailAvg30
                status
            }
        }
    }
`;

export const SEARCH_PRODUCTS = gql`
    query SearchProducts($input: SearchInput!) {
        search(input: $input) {
            items {
                productId
                slug
                productName
                variants {
                    id
                    priceWithTax
                    supplierId
                    qty
                    promotionDescription
                    shippingDate
                    supplyType
                    preOrderShippingDate
                    mov
                    moq
                    pricing {
                        fullPackageOnly
                    }
                    pricingProduct {
                        minQ
                        maxQ
                    }
                }
                quantity {
                    supplierId
                    qty
                }
                cheapestVariant {
                    id
                    supplierId
                    qty
                    priceWithTax
                    shippingDate
                    supplyType
                    preOrderShippingDate
                    mov
                    moq
                    pricing {
                        fullPackageOnly
                    }
                    pricingProduct {
                        minQ
                        maxQ
                    }
                }
                customProductMappings {
                    variantPricingIds
                    variants
                    gtin
                    brand
                }
                customProductVariantMappings {
                    pricingIds
                }
                priceWithTax {
                    ... on PriceRange {
                        min
                        max
                    }
                }
                productAsset {
                    id
                    preview
                    focalPoint {
                        x
                        y
                    }
                }
            }
            totalItems
        }
    }
`;

export const SEARCH_TOTAL_COUNT = gql`
    query SearchTotalCount($input: SearchInput!) {
        searchTotalCount(input: $input)
    }
`;

export const GET_COLLECTION = gql`
    query GetCollection($id: ID, $slug: String) {
        collection(id: $id, slug: $slug) {
            id
            name
            slug
            description
            featuredAsset {
                ...Asset
            }
            breadcrumbs {
                id
                slug
                name
            }
            children {
                id
                slug
                featuredAsset {
                    ...Asset
                }
                name
            }
        }
    }
    ${ASSET_FRAGMENT}
`;

export const SEARCH_FACET_VALUES = gql`
    query SearchFacetValues(
        $input: SearchInput!
        $take: Int!
        $skip: Int!
        $filterTerm: String
    ) {
        searchFacetValues(
            input: $input
            take: $take
            skip: $skip
            filterTerm: $filterTerm
        ) {
            items {
                count
                facetValue {
                    id
                    name
                    facet {
                        id
                        name
                    }
                }
            }
            totalItems
        }
    }
`;

export const GET_SUPPLIER_INFO = gql`
    mutation GetSupplierInfo($supplierId: ID!) {
        getSupplierInfo(id: $supplierId) {
            id
            code
            mov
            promotionDescription
            promotionTextColor
            supplyType
            leadTimeFrom
            leadTimeTo
            prePaymentPercentage
            fullPackageOnly
            preOrderShippingDate
            volumeDiscounts
        }
    }
`;

export const GET_ACTIVE_ORDER = gql`
    query GetActiveOrder {
        activeOrder {
            id
            code
            state
            totalWithTax
            lines {
                id
                quantity
                linePriceWithTax
                discountedLinePriceWithTax
                productVariant {
                    id
                    name
                    sku
                        pricing {
                            id
                        }
                    }
                }
            }
        }
    `;


